// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

// This compiler can be substituted with `up-poll` once unpoly is upgraded to v2
up.compiler('[periodically-reloading]', (element) => {
  const testEnvironment = document.querySelector('body').getAttribute('data-environment') === 'test'
  const interval = 5_000
  let intervalID

  function reload() {
    up.reload(element)
  }

  function init() {
    if (testEnvironment) {
      up.on('periodically-reloading:force-auto-reload', reload)
    } else {
      intervalID = setInterval(reload, interval)
    }
  }

  init()

  return function() {
    if (testEnvironment) {
      up.off('periodically-reloading:force-auto-reload', reload)
    } else {
      clearInterval(intervalID)
    }
  }
})
